import { h } from 'preact';
import style from "./style.css";
import cx from 'classnames';

const Feeds = () => (
    <div className={cx(style.feeds, 'flex', 'flex-1', 'flex-col', 'items-center', 'justify-center')}>
        <div className={style.label}>
            SCORES ARE DRIVEN BY:
        </div>
        <div className={cx(style.redLine, 'flex')}>
        </div>
        <div className={cx(style.feedLogos, 'flex', 'flex-row', 'justify-between', 'items-center')}>
            <img className={cx('flex')} src={'/assets/feeds/optaLogo.png'}/>
            <img className={cx('flex')} src={'/assets/feeds/runningBallLogo.png'}/>
        </div>
    </div>
);

export default Feeds;


// WEBPACK FOOTER //
// ./components/Feeds/index.jsx